const langtrans={
      fhssyy:["返回上一页","Back"],
      ksjy:["开始救援","Starting service"],
      lcsy:["流程示意","Flow chart"],
      jyffwq:["救援服务清单","Service list"],
      kscczz:["开始操作","Start operation"],
      qjtjjd:["其他节点：","Other Nodes："],
	  qtjdjl:['其他节点记录','Other Node'],
      xgssym:["修改说明及相关单据","Specification of modificatioons and relevant documents"],
      xgjjdd:["修改节点成功","Modify node successfully"],
      xgjj:["修改节点","Modify node"],
      cczzzs:["操作说明：","specification of operation："],
      xxgdcs:["相关单据上传：","Upload relevant documents："],
      xzz:["下载","Download"],
      jywc:["救援完成","Assistance completed"],
      ajcczz:["案件操作","Case operation"],
      tjcczz:["添加操作说明","Add Operation Specification:"],
      cczzzj:["操作进展","Operation progress"],
      tjfj:["添加附件","Attach files"],
      sc:["删除","Delete"],
      wcgccz:["完成该操作","Complete operation"],
      fjjssy:["附件及说明修改","Attachment and specification of modifications"],
      xgcczz:["修改操作说明","Specification of modification of operation"],
      wcxg:["完成修改","Finish modification"],
      tppmcc:["图片名称","Type of Images"],
      yldcsj:["医疗单据","Medical documents"],
      tppddz:["图片地址","Image location"],
      qd:["确定","Confirm"],
      wcjyaj:["完成救援案件","End of operation"],
      bjjj:["、报价","Quotation"],
      ztbtbj:["整体报价","Total"],
      jyfy:["救援费用","Operation fee"],
      ajfy:["案件费用","Case fee"],
      ylfy:["医疗费用","Medical cost"],
      sjfy:["、实际费用","、Actual cost"],
      qsrje:["请输入金额！","Please enter the amount"],
      qjtfy:["客户自费","Other cost"],
      qjtfys:["其他费用说明","Other cost"],
      qrtdsj:["确认提交","Confirm and submit"],
      tjjjdd:["添加节点","Add node"],
      tjjjdcg:["添加节点成功","Add node successfully"],
      qtjjjd:["请添加节点","Please add node"],
      tj:["添加","Add"],
      qrxg:["确认修改","Confirm modification"],
      qbbfyy:["请不要输入过多节点，默认显示五条","en_translated"],
      jjddmc:["节点名称不能为空！","The node name cannot be empty"],
      qsrsss:["请输入数字，而非其他","Please enter numbers only"],
      qwcsyy:["请完成所有操作！","Please complete all operations"],
      nrbbfn:["内容不能为空！","en_translated"],
      tjcg:["添加成功","Added successfully"],
      xgcg:["修改成功","The modification is successful"],
	  ajxq:["案件详情","Details of the case"],
	  khxm:["客户姓名","Name"],
	  ajh:["案件号","CaseId"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/resstep.vue.trans.js